import { useEffect, useState, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment/moment";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useHttpClient } from "../../../../shared/hooks/http-hook";
import { AuthContext } from "../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../shared/context/clinica-context";
import { useLoading } from "../../../../shared/context/LoadingContext";
//Antd
import { Popover } from "antd";

//MUI
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import Typography from "@mui/material/Typography";

import "./Procedimento.scss";
import ModalAdicionarEvolucao from "./ModalAdicionarEvolucao";
import ModalExecutarTratamentoIsolado from "./ModalExecutarTratamentoIsolado";
import SeletorUnidadeDados, {
  TODAS_UNIDADES,
} from "../../../../shared/components/badgeUnidade/SeletorUnidadeDados";
import BadgeUnidade from "../../../../shared/components/badgeUnidade/BadgeUnidade";
import BadgeCobertura from "../../../../shared/components/badgeCobertura/BadgeCobertura";
import {
  paramsUnidadeDados,
  queryUnidadeDados,
  podeAlterarRegisto,
  motivoBloqueioUnidade,
  nomeUnidadeEscolhida,
} from "../../../../shared/util/unidadeRegisto";
import toast from "react-hot-toast";

//Motivo de falta
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import ObservacoesAgendamentoTooltip from "../../components/observacoesAgendamentoTooltirp/ObservacoesAgendamentoTooltip";
import { Tooltip } from "@mui/material";
import { AlertTriangle } from "lucide-react";

const MOTIVOS_FALTA = [
  "AGENDAMENTO_CANCELADO",
  "CONDICAO_CLIMATICA",
  "DOENCA",
  "EMERGENCIA_FAMILIAR",
  "ESQUECIMENTO",
  "MELHORA_DOS_SINTOMAS",
  "PROBLEMAS_FINANCEIROS",
  "SEM_CONTACTO",
  "TRANSPORTE",
  "OUTRO",
];

const MOTIVOS_FALTA_LEGIVEL = {
  AGENDAMENTO_CANCELADO: "Agendamento Cancelado",
  CONDICAO_CLIMATICA: "Condições climáticas",
  DOENCA: "Doença",
  EMERGENCIA_FAMILIAR: "Emergência familiar",
  ESQUECIMENTO: "Esquecimento",
  MELHORA_DOS_SINTOMAS: "Melhora dos sintomas",
  PROBLEMAS_FINANCEIROS: "Problemas financeiros",
  SEM_CONTACTO: "Sem contacto",
  TRANSPORTE: "Problemas de transporte",
  OUTRO: "Outro motivo",
};

const MOTIVOS_NAO_EXECUCAO = [
  "CRIANCA_NAO_COLABOROU",
  "PACIENTE_NAO_COLABOROU",
  "CONDICAO_CLINICA_INADEQUADA",
  "EQUIPAMENTO_INDISPONIVEL",
  "OUTRO",
];

const MOTIVOS_NAO_EXECUCAO_LEGIVEL = {
  CRIANCA_NAO_COLABOROU: "Criança não colaborou",
  PACIENTE_NAO_COLABOROU: "Paciente não colaborou",
  CONDICAO_CLINICA_INADEQUADA: "Condição clínica inadequada",
  EQUIPAMENTO_INDISPONIVEL: "Equipamento indisponível",
  OUTRO: "Outro motivo",
};

function ProcedimentosTratamento({ visualizarPdf, listaPresencaProp }) {
  const { startLoading, stopLoading } = useLoading();

  const [marcacoes, setMarcacoes] = useState();
  const [dataSelectAtendimentosDe, setDataSelectAtendimentosDe] =
    useState("hoje");
  const [nrMarcacoes, setNrMarcacoes] = useState(0);
  const [listaPresenca, setListaPresenca] = useState([]);
  const [dataDatePicker, setDataDatePicker] = useState(moment());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const { sendRequest } = useHttpClient();
  const [verAtendidos, setVerAtendidos] = useState(false);
  // Estado à parte de propósito: compromissos não são atendimentos e não podem
  // entrar nos contadores (ficariam eternamente "por atender"). Só se juntam às
  // marcações na renderização da tabela.
  const [compromissos, setCompromissos] = useState([]);
  // Desligado por omissão: a lista é dos atendimentos do dia, e os compromissos
  // empurram-nos para baixo. Quem os quiser ver liga o interruptor.
  const [verCompromissos, setVerCompromissos] = useState(false);

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  /* De que unidade são as marcações deste ecrã. Arranca na da sessão: quem
     abre a lista do dia está a atender num sítio concreto.
     Fica DEPOIS do `auth` de propósito — o inicializador lê-o, e antes disso
     rebentava com «Cannot access 'auth' before initialization». */
  const [unidadeDados, setUnidadeDados] = useState(
    () => auth.estabelecimento?._id ?? null,
  );
  const verTodasUnidades = unidadeDados === TODAS_UNIDADES;

  // O dia que está a ser mostrado. Ver a nota no `fetchMarcacoesByDate`.
  const diaEmVista = useRef(moment());

  const [dadosModal, setDadosModal] = useState({});
  const [openModal, setOpenModal] = useState("");

  // Estados para o diálogo de confirmação de falta
  const [motivoFaltaDialogOpen, setMotivoFaltaDialogOpen] = useState(false);
  const [marcacaoIdParaFalta, setMarcacaoIdParaFalta] = useState(null);

  const [motivoNaoExecucaoDialogOpen, setMotivoNaoExecucaoDialogOpen] =
    useState(false);
  const [marcacaoIdParaNaoExecucao, setMarcacaoIdParaNaoExecucao] =
    useState(null);

  const [orcamentoDialogData, setOrcamentoDialogData] = useState({
    open: false,
  });
  const [clienteRecemChegado, setClienteRecemChegado] = useState(null);

  const [imprimirDialogOpen, setImprimirDialogOpen] = useState(false);

  useEffect(() => {
    // Só detectar novos clientes se já tínhamos uma lista anterior (evita falso positivo no primeiro load)
    if (
      listaPresenca.length > 0 &&
      listaPresencaProp.length > listaPresenca.length
    ) {
      const novoCliente = listaPresencaProp.find(
        (novoItem) =>
          !listaPresenca.some(
            (antigoItem) => antigoItem.clienteId === novoItem.clienteId,
          ),
      );

      if (novoCliente) {
        setClienteRecemChegado(novoCliente.clienteId);

        // Remover o destaque após 5 segundos
        setTimeout(() => {
          setClienteRecemChegado(null);
        }, 5000);
      }
    }

    setListaPresenca(listaPresencaProp);
  }, [listaPresencaProp, listaPresenca]);

  useEffect(() => {
    fetchMarcacoesByDate(moment());
  }, [sendRequest, clinica, auth]);

  const navigate = useNavigate();

  const fetchMarcacoesByDate = async (data, unidade = unidadeDados) => {
    /* O dia realmente em vista, seja qual for o caminho que o escolheu.
     *
     * Não se pode usar o `dataDatePicker`: o seletor «ontem / hoje / amanhã»
     * chama este fetch mas não mexe nesse estado, por isso ele fica em hoje.
     * Trocar de unidade com «ontem» escolhido saltava a lista para hoje sem
     * dizer nada.
     *
     * É `ref` e não estado porque só serve para o próximo pedido. */
    diaEmVista.current = data;

    startLoading();
    try {
      const formData = new FormData();
      formData.append("medico", auth.userId);
      formData.append("date", data);

      /* Trocar de unidade é um pedido novo, não um recorte do que já veio.
         Sem parâmetros o servidor devolve a unidade da sessão. */
      for (const [chave, valor] of Object.entries(
        paramsUnidadeDados(unidade, auth),
      )) {
        formData.append(chave, valor);
      }

      const [
        responseMarcacoesAgenda,
        responseMarcacoesAgendaTransicao,
        responseMarcacoesTratamentoIsolados,
        responseCompromissos,
      ] = await Promise.all([
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/agendatratamento/marcacoesmedico/specificdate/${clinica.clinica._id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        ),
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentostratamentoemtransicao/marcacoesmedico/specificDate/${clinica.clinica._id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        ),
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/marcacoesmedico/specificDate/${clinica.clinica._id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        ),
        // Limites do dia calculados aqui, no fuso de quem está a ver.
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/compromissos/listaatendimento/${clinica.clinica._id}?medicos=${auth.userId}&startDate=${encodeURIComponent(
            moment(data).startOf("day").toISOString(),
          )}&endDate=${encodeURIComponent(
            moment(data).endOf("day").toISOString(),
          )}${queryUnidadeDados(unidade, auth, true)}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        ),
      ]);

      filterMarcacoes(
        responseMarcacoesAgenda.marcacoes,
        responseMarcacoesAgendaTransicao.marcacoes,
        responseMarcacoesTratamentoIsolados.tratamentoIsolados,
      );

      setCompromissos(
        (responseCompromissos.compromissos || []).map((c) => ({
          id: c._id,
          isCompromisso: true,
          compromisso: c.compromisso,
          data_inicio_execucao: c.data_inicio_execucao,
          data_fim_execucao: c.data_fim_execucao,
          estabelecimento: c.estabelecimento,
        })),
      );
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const verPdf = (incluirObservacoes) => {
    let tempProcedimentos;
    tempProcedimentos = marcacoes.map((mr) => {
      const procedimentoBase = {
        cliente: mr.nome,
        contacto: mr.contacto,
        data_inicio_execucao: mr.data_inicio_execucao,
        data_fim_execucao: mr.data_fim_execucao,
      };

      if (incluirObservacoes && mr.observacoesAgendamento) {
        procedimentoBase.observacoesAgendamento = mr.observacoesAgendamento;
      }

      if (mr.avaliacao) {
        return {
          ...procedimentoBase,
          procedimento: "Avaliação",
        };
      } else {
        return {
          ...procedimentoBase,
          procedimento: mr.tratamento.designacao,
        };
      }
    });

    // A unidade escolhida no filtro vai para o cabeçalho da lista impressa.
    visualizarPdf(
      tempProcedimentos,
      incluirObservacoes,
      nomeUnidadeEscolhida(unidadeDados, auth, marcacoes),
    );
  };

  const handleImprimir = () => {
    setImprimirDialogOpen(true);
  };

  const confirmarImpressao = (incluirObservacoes) => {
    verPdf(incluirObservacoes);
    setImprimirDialogOpen(false);
  };

  const handleAvaliar = async (idCliente, marcacaoId) => {
    startLoading();
    navigate(`/avaliacao/new/${idCliente}-${marcacaoId}`);
  };

  const handleAdicionarEvolucao = (row) => {
    setOpenModal("evolucao");
    setDadosModal({
      id: row.id,
      nome: row.nome,
      idCliente: row.idCliente,
      tratamento: row.tratamento,
      data_inicio_execucao: row.data_inicio_execucao,
      data_fim_execucao: row.data_fim_execucao,
    });
  };

  const handleCloseModal = () => {
    setDadosModal(null);
    setOpenModal("");
  };

  const handleModalSubmitSuccess = (id, tratamentoIsoladoComAlteracao) => {
    handleCloseModal();

    if (tratamentoIsoladoComAlteracao) {
      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) =>
          m.id === id
            ? {
                ...m,
                atendido: true,
                tratamento: tratamentoIsoladoComAlteracao,
              }
            : m,
        ),
      );
    } else {
      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) => (m.id === id ? { ...m, atendido: true } : m)),
      );
    }
  };

  const marcarFalta = async (marcacaoId, motivoTipo, motivoDetalhes) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("utilizador", auth.userId);

      formData.append("motivoFaltaTipo", motivoTipo);
      formData.append("motivoFaltaDetalhes", motivoDetalhes);

      let path = "agendatratamento";
      const marcacaoFiltrada = marcacoes.filter((m) => m.id === marcacaoId)[0];

      if (marcacaoFiltrada && marcacaoFiltrada.tratamentoIsolado) {
        path = "tratamentoIsolados";
      } else if (marcacaoFiltrada && marcacaoFiltrada.emTransicao) {
        path = "agendamentostratamentoemtransicao";
      }

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/marcarfalta/${marcacaoId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const toUpdate = { faltou: true, atendido: false };

      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) => {
          if (m.id === marcacaoId) {
            return { ...m, ...toUpdate };
          } else {
            return m;
          }
        }),
      );

      toast.success("Falta marcada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const handleMarcarNaoExecutado = async (
    marcacaoId,
    motivoTipo,
    motivoDetalhes,
  ) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("utilizador", auth.userId);
      formData.append("motivoNaoExecucaoTipo", motivoTipo);
      formData.append("motivoNaoExecucaoDetalhes", motivoDetalhes);

      let path = "agendatratamento";
      const marcacaoFiltrada = marcacoes.filter((m) => m.id === marcacaoId)[0];

      if (marcacaoFiltrada && marcacaoFiltrada.tratamentoIsolado) {
        path = "tratamentoIsolados";
      } else if (marcacaoFiltrada && marcacaoFiltrada.emTransicao) {
        path = "agendamentostratamentoemtransicao";
      }

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/marcarnaoexecutado/${marcacaoId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const toUpdate = {
        faltou: false,
        atendido: true,
        atendimentoNaoExecutado: true,
      };

      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) => {
          if (m.id === marcacaoId) {
            return { ...m, ...toUpdate };
          } else {
            return m;
          }
        }),
      );

      toast.success("Agendamento marcado como atendido mas não executado!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const removerFalta = async (marcacaoId) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("utilizador", auth.userId);

      let path = "agendatratamento";
      const marcacaoFiltrada = marcacoes.find((m) => m.id === marcacaoId);

      if (marcacaoFiltrada && marcacaoFiltrada.tratamentoIsolado) {
        path = "tratamentoIsolados";
      } else if (marcacaoFiltrada && marcacaoFiltrada.emTransicao) {
        path = "agendamentosemtransicao";
      }

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/removerfalta/${marcacaoId}`,
        "PATCH",
        formData,
        { Authorization: "Bearer " + auth.token },
      );

      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) =>
          m.id === marcacaoId ? { ...m, faltou: false } : m,
        ),
      );

      toast.success("Falta removida com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const handleMarcarAtendido = async (marcacaoId) => {
    startLoading();
    try {
      const formData = new FormData();

      let path = "agendatratamento";
      const marcacaoFiltrada = marcacoes.find((m) => m.id === marcacaoId);

      if (marcacaoFiltrada && marcacaoFiltrada.emTransicao) {
        path = "agendamentostratamentoemtransicao";
      }
      if (marcacaoFiltrada && marcacaoFiltrada.tratamentoIsolado) {
        path = "tratamentoIsolados";
      }

      formData.append("utilizador", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/${path}/marcaratendido/${marcacaoId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      toast.success("Agendamento marcado como atendido.");

      const toUpdate = { faltou: false, atendido: true };

      setMarcacoes((prevMarcacoes) =>
        prevMarcacoes.map((m) => {
          if (m.id === marcacaoId) {
            return { ...m, ...toUpdate };
          } else {
            return m;
          }
        }),
      );
      // }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  /* Sem `useCallback`, e de propósito.
   *
   * Estava memoizado com lista de dependências VAZIA, o que o congelava na
   * primeira renderização — e com ele o `fetchMarcacoesByDate` dessa passagem,
   * cujo valor por omissão `unidade = unidadeDados` ficava preso na unidade com
   * que se entrou na sessão.
   *
   * O efeito era a ordem passar a contar: escolher a unidade e depois o dia
   * pedia o dia novo à unidade ANTIGA, e a lista aparecia vazia; pela ordem
   * inversa funcionava, porque o seletor de unidade passa a unidade por
   * argumento e lê o dia de um `ref`, que não envelhece.
   *
   * Memoizar o `onChange` de um `<select>` não poupa nada, e a lista vazia era
   * falsa: esta função depende mesmo do que está no ecrã. */
  const changeSelectAtendimentosDe = (e) => {
    setDataSelectAtendimentosDe(e.target.value);
    if (e.target.value === "escolher-data") {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
      if (e.target.value === "ontem") {
        fetchMarcacoesByDate(moment().subtract(1, "days"));
      } else if (e.target.value === "amanha") {
        fetchMarcacoesByDate(moment().add(1, "days"));
      } else {
        fetchMarcacoesByDate(moment());
      }
    }
  };

  const filterMarcacoes = (
    marcacoesAgenda,
    marcacoesEmTransicao,
    marcacoesTratamentoIsolado,
  ) => {
    const tempMarcacoes = [];
    marcacoesAgenda.forEach((mr) => {
      tempMarcacoes.push({
        id: mr._id,
        nome: mr.cliente.nome,
        contacto: mr.cliente.contacto,
        data_inicio_execucao: mr.data_inicio_execucao,
        data_fim_execucao: mr.data_fim_execucao,
        /* `planoTratamento` passou a vir POPULADO (traz a cobertura do
           orçamento), por isso já não é um id — e isto vai direto para o
           URL de executar o plano. Sem o `._id`, o link ficava
           «/planotratamento/executar/[object Object]-…». */
        idPlano: mr.avaliacao
          ? null
          : mr.planoTratamento?._id || mr.planoTratamento,
        orcamento: mr.orcamento,
        cobertura:
          mr.orcamento?.beneficio ||
          mr.planoTratamento?.orcamento?.beneficio ||
          null,
        idOrcamento: mr.orcamento,
        idCliente: mr.cliente._id,
        tratamento: mr.tratamento,
        avaliacao: mr.avaliacao ? true : false,
        atendido: mr.atendido,
        faltou: mr.faltou,
        atendimentoNaoExecutado: mr.atendimentoNaoExecutado,
        observacoesAgendamento: mr.observacoesAgendamento,
        // Sem isto a linha perde a unidade a caminho da tabela, e nem a
        // pastilha nem o bloqueio das ações têm por onde se decidir.
        estabelecimento: mr.estabelecimento,
        alergias: mr.cliente.anamnese?.alergias || null,
      });
    });

    marcacoesEmTransicao.forEach((mr) => {
      tempMarcacoes.push({
        id: mr._id,
        nome: mr.cliente.nome,
        contacto: mr.cliente.contacto,
        data_inicio_execucao: mr.data_inicio_execucao,
        data_fim_execucao: mr.data_fim_execucao,
        idCliente: mr.cliente._id,
        tratamento: mr.tratamento,
        avaliacao: mr.avaliacao ? true : false,
        atendido: mr.atendido,
        faltou: mr.faltou,
        atendimentoNaoExecutado: mr.atendimentoNaoExecutado,
        emTransicao: true,
        observacoesAgendamento: mr.observacoesAgendamento,
        // Sem isto a linha perde a unidade a caminho da tabela, e nem a
        // pastilha nem o bloqueio das ações têm por onde se decidir.
        estabelecimento: mr.estabelecimento,
        alergias: mr.cliente.anamnese?.alergias || null,
      });
    });

    marcacoesTratamentoIsolado.forEach((mr) => {
      tempMarcacoes.push({
        id: mr._id,
        nome: mr.cliente.nome,
        contacto: mr.cliente.contacto,
        data_inicio_execucao: mr.data_inicio_execucao,
        data_fim_execucao: mr.data_fim_execucao,
        idCliente: mr.cliente._id,
        tratamentoIsolado: true,
        // Um tratamento isolado não pertence a orçamento nenhum — não há
        // cobertura a mostrar, e a etiqueta di-lo por extenso.
        cobertura: "TI",
        atendido: mr.atendido,
        faltou: mr.faltou,
        atendimentoNaoExecutado: mr.atendimentoNaoExecutado,
        observacoesAgendamento: mr.observacoesAgendamento,
        // Sem isto a linha perde a unidade a caminho da tabela, e nem a
        // pastilha nem o bloqueio das ações têm por onde se decidir.
        estabelecimento: mr.estabelecimento,
        tratamento: mr.tratamento,
        entrada: mr.entrada,
      });
    });

    const temp = tempMarcacoes.sort((a, b) => {
      return (
        new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao)
      );
    });

    setMarcacoes(tempMarcacoes);
    setNrMarcacoes(temp.length);
  };

  const changeDataDatePicker = async (value) => {
    setDataDatePicker(value);
    if (value && moment(value).isValid()) {
      fetchMarcacoesByDate(value);
    }
  };

  const handleExecutarTratamentoIsolado = (row) => {
    setOpenModal("tratamentoIsolado");
    setDadosModal({
      id: row.id,
      nome: row.nome,
      idCliente: row.idCliente,
      data_inicio_execucao: row.data_inicio_execucao,
      data_fim_execucao: row.data_fim_execucao,
      tratamento: row.tratamento,
      entrada: row.entrada,
    });
  };

  // Abre o diálogo e guarda o ID da marcação
  const abrirDialogoMotivoFalta = (marcacaoId) => {
    setMarcacaoIdParaFalta(marcacaoId);
    setMotivoFaltaDialogOpen(true);
  };

  // Fecha o diálogo
  const fecharDialogoMotivoFalta = () => {
    setMotivoFaltaDialogOpen(false);
    setMarcacaoIdParaFalta(null);
  };

  const abrirDialogoMotivoNaoExecucao = (marcacaoId) => {
    setMarcacaoIdParaNaoExecucao(marcacaoId);
    setMotivoNaoExecucaoDialogOpen(true);
  };

  const fecharDialogoMotivoNaoExecucao = () => {
    setMotivoNaoExecucaoDialogOpen(false);
    setMarcacaoIdParaNaoExecucao(null);
  };

  // Função para o formulário de envio (que evita o uso de states)
  const submeterFormularioFalta = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const motivoTipo = formData.get("motivoFaltaTipo");
    const motivoDetalhes = formData.get("motivoFaltaDetalhes");

    if (!motivoTipo) {
      toast.error("Por favor, selecione o motivo da falta.");
      return;
    }

    marcarFalta(marcacaoIdParaFalta, motivoTipo, motivoDetalhes);
    fecharDialogoMotivoFalta();
  };

  const submeterFormularioNaoExecucao = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const motivoTipo = formData.get("motivoNaoExecucaoTipo");
    const motivoDetalhes = formData.get("motivoNaoExecucaoDetalhes");

    if (!motivoTipo) {
      toast.error("Por favor, selecione o motivo da não execução.");
      return;
    }

    handleMarcarNaoExecutado(
      marcacaoIdParaNaoExecucao,
      motivoTipo,
      motivoDetalhes,
    );
    fecharDialogoMotivoNaoExecucao();
  };

  const handleExecutarOrcamento = (dados) => {
    setOrcamentoDialogData({ dados: dados, open: true });
  };

  // Função auxiliar para verificar se cliente está presente e obter horário
  const getClientePresenca = (clienteId) => {
    const presente = listaPresenca.find((item) => item.clienteId === clienteId);
    return presente || null;
  };

  // Função para formatar horário
  const formatarHorario = (horarioChegada) => {
    return moment(horarioChegada).format("HH:mm");
  };

  // Compromissos entram na ordem cronológica, entre os atendimentos. Não têm
  // estado, por isso o filtro "Ver Atendidos" não os afeta.
  const marcacoesVisiveis = (marcacoes || []).filter(
    (row) =>
      verAtendidos ||
      !(row.atendido || row.faltou || row.atendimentoNaoExecutado),
  );
  const linhasVisiveis = [
    ...marcacoesVisiveis,
    ...(verCompromissos ? compromissos : []),
  ].sort(
    (a, b) =>
      new Date(a.data_inicio_execucao) - new Date(b.data_inicio_execucao),
  );
  // Todas as linhas são do mesmo dia; a primeira serve para saber se é hoje.
  const mostrarPresenca =
    linhasVisiveis.length > 0 &&
    moment(linhasVisiveis[0].data_inicio_execucao).isSame(moment(), "days");
  const numColunas = mostrarPresenca ? 8 : 7;

  return (
    <>
      {openModal === "evolucao" && dadosModal && (
        <ModalAdicionarEvolucao
          handleCloseModal={handleCloseModal}
          open={openModal === "evolucao"}
          dados={dadosModal}
          auth={auth}
          sendRequest={sendRequest}
          handleModalSubmitSuccess={handleModalSubmitSuccess}
        />
      )}

      {openModal === "tratamentoIsolado" && dadosModal && (
        <ModalExecutarTratamentoIsolado
          handleCloseModal={handleCloseModal}
          open={openModal === "tratamentoIsolado"}
          dados={dadosModal}
          auth={auth}
          sendRequest={sendRequest}
          handleModalSubmitSuccess={handleModalSubmitSuccess}
        />
      )}

      {/* Modal para o motivo da falta com formulário */}
      <Dialog
        open={motivoFaltaDialogOpen}
        onClose={fecharDialogoMotivoFalta}
        aria-labelledby="motivo-falta-dialog-title"
      >
        <form onSubmit={submeterFormularioFalta}>
          <DialogTitle id="motivo-falta-dialog-title">
            {"Registrar motivo da falta"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: "20px" }}>
              Selecione o motivo da falta do paciente para registro no sistema.
            </DialogContentText>

            <FormControl fullWidth required style={{ marginBottom: "20px" }}>
              <InputLabel id="motivo-falta-tipo-label">
                Motivo da Falta
              </InputLabel>
              <Select
                labelId="motivo-falta-tipo-label"
                id="motivoFaltaTipo"
                name="motivoFaltaTipo"
                label="Motivo da Falta"
                defaultValue=""
              >
                {MOTIVOS_FALTA.map((motivo) => (
                  <MenuItem key={motivo} value={motivo}>
                    {MOTIVOS_FALTA_LEGIVEL[motivo]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextareaAutosize
              aria-label="detalhes da falta"
              name="motivoFaltaDetalhes"
              minRows={3}
              placeholder="Detalhes adicionais (opcional)"
              style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={fecharDialogoMotivoFalta}
              type="button"
              color="primary"
            >
              Cancelar
            </Button>
            <Button type="submit" color="error" autoFocus>
              Confirmar Falta
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={motivoNaoExecucaoDialogOpen}
        onClose={fecharDialogoMotivoNaoExecucao}
        aria-labelledby="motivo-nao-execucao-dialog-title"
      >
        <form onSubmit={submeterFormularioNaoExecucao}>
          <DialogTitle id="motivo-nao-execucao-dialog-title">
            {"Registrar motivo de não execução"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ marginBottom: "20px" }}>
              O paciente compareceu mas o procedimento não foi executado.
              Selecione o motivo para registro no sistema.
            </DialogContentText>

            <FormControl fullWidth required style={{ marginBottom: "20px" }}>
              <InputLabel id="motivo-nao-execucao-tipo-label">
                Motivo da Não Execução
              </InputLabel>
              <Select
                labelId="motivo-nao-execucao-tipo-label"
                id="motivoNaoExecucaoTipo"
                name="motivoNaoExecucaoTipo"
                label="Motivo da Não Execução"
                defaultValue=""
              >
                {MOTIVOS_NAO_EXECUCAO.map((motivo) => (
                  <MenuItem key={motivo} value={motivo}>
                    {MOTIVOS_NAO_EXECUCAO_LEGIVEL[motivo]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextareaAutosize
              aria-label="detalhes da não execução"
              name="motivoNaoExecucaoDetalhes"
              minRows={3}
              placeholder="Detalhes adicionais (opcional)"
              style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={fecharDialogoMotivoNaoExecucao}
              type="button"
              color="primary"
            >
              Cancelar
            </Button>
            <Button type="submit" color="warning" autoFocus>
              Confirmar Não Execução
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Modal para mensagem de agendamento de orcamento */}
      <Dialog
        open={orcamentoDialogData.open}
        onClose={() => setOrcamentoDialogData({ open: false })}
      >
        <DialogTitle>Orçamento não aprovado</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Trata-se de um agendamento provisório de um orçamento{" "}
            {`(Cod: ${orcamentoDialogData.dados?.orcamento?.codigo})`} que não
            foi aprovado. Aprove o orçamento para poder executar o procedimento!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOrcamentoDialogData({ open: false })}
            color="primary"
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <div className="marcacoes-secretaria-header-row">
        <div className="box-escolha-de-dia">
          <span className="box-title box-title--atendimentosSecretaria">
            Atendimentos de:{" "}
          </span>
          <select
            onChange={changeSelectAtendimentosDe}
            value={dataSelectAtendimentosDe}
          >
            <option value="ontem">Ontem</option>
            <option value="hoje">Hoje</option>
            <option value="amanha">Amanhã</option>
            <option value="escolher-data">Escolher Data</option>
          </select>

          {showDatePicker && (
            <div>
              <LocalizationProvider
                dateAdapter={AdapterMoment}
                className="adicionar-despesa__modal__container--span1"
              >
                <DesktopDatePicker
                  className="valorDataCaixa__fields--field muiDatePicker"
                  label="Data*"
                  inputFormat="DD-MM-YYYY"
                  renderInput={(params) => <TextField {...params} />}
                  onChange={(value) => changeDataDatePicker(value)}
                  value={dataDatePicker}
                  onError={(error) => {}} // suprime o erro visual durante digitação
                />
              </LocalizationProvider>
            </div>
          )}
          <span className="box-title box-title--atendimentosSecretaria">{`${nrMarcacoes} marcações`}</span>

          {/* De que unidade são estas marcações. Trocar refaz o pedido ao
              servidor, com o dia que está a ser visto. */}
          <SeletorUnidadeDados
            valor={unidadeDados}
            onChange={(nova) => {
              setUnidadeDados(nova);
              // A unidade nova vai por argumento: o `setState` ainda não se vê
              // nesta passagem, e o pedido sairia com a antiga.
              fetchMarcacoesByDate(diaEmVista.current, nova);
            }}
          />

          <div
            className="checkbox-wrapper-51"
            id="ver-atendidos__checkbox-container"
          >
            <span className="box-title box-title--atendimentosSecretaria">
              Ver Atendidos
            </span>
            <input
              type="checkbox"
              id="mostrarRecebidos"
              onChange={(e) => setVerAtendidos(e.target.checked)}
              checked={verAtendidos}
            />
            <label htmlFor="mostrarRecebidos" className="toggle">
              <span>
                <svg width="10px" height="10px" viewBox="0 0 10 10">
                  <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
                </svg>
              </span>
            </label>
          </div>

          <div
            className="checkbox-wrapper-51"
            id="ver-compromissos__checkbox-container"
          >
            <span className="box-title box-title--atendimentosSecretaria">
              Ver Compromissos
            </span>
            <input
              type="checkbox"
              id="mostrarCompromissos"
              onChange={(e) => setVerCompromissos(e.target.checked)}
              checked={verCompromissos}
            />
            <label htmlFor="mostrarCompromissos" className="toggle">
              <span>
                <svg width="10px" height="10px" viewBox="0 0 10 10">
                  <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
                </svg>
              </span>
            </label>
          </div>
        </div>

        <div>
          <span className="blue-button" onClick={handleImprimir}>
            Imprimir
          </span>
        </div>
      </div>

      {linhasVisiveis.length > 0 && (
        <TableContainer component={Paper} className="tableMarcacoes">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead style={{ backgroundColor: "white" }}>
              <TableRow>
                <TableCell>Cliente</TableCell>
                <TableCell align="left">Procedimento</TableCell>
                <TableCell align="left">Inicio</TableCell>
                <TableCell align="left">Fim</TableCell>
                {mostrarPresenca && (
                  <TableCell align="left">Presente</TableCell>
                )}
                <TableCell align="left">Obs</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {linhasVisiveis.map((row, index) => {
                if (row.isCompromisso) {
                  return (
                    <TableRow key={row.id} className="row-compromisso">
                      <TableCell colSpan={2}>
                        <div className="compromisso-linha">
                          <span className="compromisso-tag">Compromisso</span>
                          <span className="compromisso-titulo">
                            {row.compromisso}
                          </span>
                          {/* A linha do compromisso é um `return` à parte e não
                              passa pela célula do cliente, onde a pastilha é
                              desenhada — sem isto, no consolidado ficava a única
                              linha da lista sem unidade. */}
                          {verTodasUnidades && (
                            <BadgeUnidade
                              estabelecimento={row.estabelecimento}
                            />
                          )}
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        {moment(row.data_inicio_execucao).format("HH:mm")}
                      </TableCell>
                      <TableCell align="left">
                        {moment(row.data_fim_execucao).format("HH:mm")}
                      </TableCell>
                      <TableCell colSpan={numColunas - 4} />
                    </TableRow>
                  );
                }
                return (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    className={
                      clienteRecemChegado === row.idCliente
                        ? "row-cliente-acabou-chegar"
                        : ""
                    }
                  >
                    <TableCell component="th" scope="row">
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <Link
                          to={`/clientes/${row.idCliente}`}
                          className="linkProcedimento"
                        >
                          {row.nome}
                        </Link>
                        <BadgeCobertura cobertura={row.cobertura} />
                        {/* Só no consolidado: com uma unidade escolhida, todas
                            as linhas são dela. */}
                        {verTodasUnidades && (
                          <BadgeUnidade estabelecimento={row.estabelecimento} />
                        )}
                        {row.alergias && row.alergias.trim() !== "" && (
                          <Tooltip
                            title={
                              <div>
                                <strong>Alergias:</strong>
                                <div style={{ whiteSpace: "pre-wrap" }}>{row.alergias}</div>
                              </div>
                            }
                            arrow
                            placement="top"
                          >
                            <span style={{ display: "inline-flex", cursor: "pointer", color: "#d32f2f" }}>
                              <AlertTriangle size={16} />
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.avaliacao ? "Avaliação" : row.tratamento?.designacao}

                      {row.orcamento && " (Orçamento)"}
                    </TableCell>
                    <TableCell align="left">
                      {moment(row.data_inicio_execucao).format("HH:mm")}
                    </TableCell>
                    <TableCell align="left">
                      {moment(row.data_fim_execucao).format("HH:mm")}
                    </TableCell>
                    {mostrarPresenca && (
                      <TableCell align="left">
                        {(() => {
                          const presenca = getClientePresenca(row.idCliente);
                          return presenca ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <div className="cliente-presente led"></div>
                              <span className="badge-horario">
                                {formatarHorario(presenca.horarioChegada)}
                              </span>
                            </div>
                          ) : (
                            <div className="cliente-nao-presente led"></div>
                          );
                        })()}
                      </TableCell>
                    )}
                    {/* Obs */}
                    <TableCell align="left">
                      <ObservacoesAgendamentoTooltip
                        observacoes={row.observacoesAgendamento}
                      />
                    </TableCell>
                    {/* Status */}
                    <TableCell align="left">
                      {row.atendido && !row.atendimentoNaoExecutado ? (
                        <span className="spanMensagemAtendido">Atendido</span>
                      ) : row.atendimentoNaoExecutado ? (
                        <span className="spanMensagemNaoExecutado">
                          Não Executado
                        </span>
                      ) : row.faltou ? (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span className="spanMensagemFaltou">Faltou</span>
                        </span>
                      ) : (
                        <></>
                      )}
                    </TableCell>

                    {/* Acoes */}
                    <TableCell
                      align="right"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {/* Marcação de outra unidade: só leitura. Executar daqui
                          usaria o catálogo de tratamentos desta unidade sobre
                          uma marcação que nasceu na outra.

                          O botão de executar aparece na mesma, e explica-se ao
                          clicar. Escondê-lo deixava a linha sem ação nenhuma e
                          o médico a pensar que era avaria; assim fica claro que
                          é uma regra, e qual. */}
                      {!podeAlterarRegisto(row.estabelecimento, auth) ? (
                        row.tratamentoIsolado &&
                        !row.atendido &&
                        !row.faltou ? (
                          <button
                            className="executarButton executarButton--outraUnidade"
                            title={motivoBloqueioUnidade(
                              row.estabelecimento,
                              "executar",
                            )}
                            onClick={() =>
                              toast.error(
                                motivoBloqueioUnidade(
                                  row.estabelecimento,
                                  "executar",
                                ),
                                { duration: 6000 },
                              )
                            }
                          >
                            Executar
                          </button>
                        ) : (
                          <span
                            className="procedimentos__outra-unidade"
                            title={motivoBloqueioUnidade(row.estabelecimento)}
                          >
                            Outra unidade
                          </span>
                        )
                      ) : (
                        <>
                      {moment(row.data_inicio_execucao).isBefore(
                        moment().add(1, "days"),
                        "day",
                      ) ? (
                        <div
                          className="dots__menu__popup"
                          style={{ minWidth: "60px" }}
                        >
                          {/* Marcar atendido */}
                          <Popover
                            content={
                              <>
                                {!row.atendido && !row.tratamentoIsolado && (
                                  <div
                                    className="popOverMenu--option"
                                    onClick={handleMarcarAtendido.bind(
                                      null,
                                      row.id,
                                    )}
                                  >
                                    <span>Marcar Atendido</span>
                                  </div>
                                )}

                                {!row.atendido && !row.faltou && (
                                  <div
                                    className="popOverMenu--option"
                                    onClick={abrirDialogoMotivoNaoExecucao.bind(
                                      null,
                                      row.id,
                                    )}
                                  >
                                    <span>Atendido sem Execução</span>
                                  </div>
                                )}

                                {row.faltou && (
                                  <div
                                    className="popOverMenu--option"
                                    onClick={removerFalta.bind(null, row.id)}
                                  >
                                    <span>Remover Falta</span>
                                  </div>
                                )}
                              </>
                            }
                            trigger="click"
                            placement="bottom"
                          >
                            <div className="dots__menu">
                              <div className="dot"></div>
                              <div className="dot"></div>
                              <div className="dot"></div>
                            </div>
                          </Popover>
                        </div>
                      ) : (
                        //êssa div é simplismente para alinhar as rows. Estilo apenas
                        <div style={{ height: "35px", padding: "10px" }}></div>
                      )}

                      {/* Botão Faltou - aparece para qualquer data.
                          Só na unidade da marcação: estava FORA da guarda de
                          unidade, que fecha mais acima, e um médico marcava
                          faltas de marcações do outro balcão. */}
                      {podeAlterarRegisto(row.estabelecimento, auth) &&
                        !row.atendido &&
                        !row.faltou &&
                        !getClientePresenca(row.idCliente) && (
                          <button
                            className="faltouButton"
                            onClick={abrirDialogoMotivoFalta.bind(null, row.id)}
                          >
                            Faltou
                          </button>
                        )}

                      {/* Botões de ação - apenas para o dia atual */}
                      {/* {moment(row.data_inicio_execucao).isSame(
                        moment(),
                        "day"
                      ) && */}
                      {!row.atendido && !row.faltou && (
                        <>
                          {!row.avaliacao &&
                          !row.emTransicao &&
                          !row.orcamento &&
                          !row.tratamentoIsolado ? (
                            <Link
                              to={`/planotratamento/executar/${row.idPlano}-${row.id}-${row.idCliente}`}
                              className="linkProcedimento"
                            >
                              <button className="executarButton">
                                Executar
                              </button>
                            </Link>
                          ) : row.tratamentoIsolado ? (
                            <button
                              className="executarButton"
                              onClick={handleExecutarTratamentoIsolado.bind(
                                null,
                                row,
                              )}
                            >
                              Executar
                            </button>
                          ) : row.orcamento ? (
                            <button
                              className="executarButton executarButton--orcamento"
                              onClick={handleExecutarOrcamento.bind(null, row)}
                            >
                              INFO
                            </button>
                          ) : row.avaliacao ? (
                            <button
                              className="executarButton"
                              onClick={handleAvaliar.bind(
                                null,
                                row.idCliente,
                                row.id,
                              )}
                            >
                              Avaliar
                            </button>
                          ) : (
                            <button
                              className="executarButton"
                              onClick={handleAdicionarEvolucao.bind(null, row)}
                            >
                              Evolução
                            </button>
                          )}
                        </>
                      )}
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {marcacoes && marcacoes.length === 0 && (
        <span className="spanNenhumProcedimento">
          Nenhum procedimento agendado para hoje
        </span>
      )}

      {/* Modal para escolher se imprime com ou sem observações */}
      <Dialog
        open={imprimirDialogOpen}
        onClose={() => setImprimirDialogOpen(false)}
        aria-labelledby="imprimir-dialog-title"
      >
        <DialogTitle id="imprimir-dialog-title">
          Opções de Impressão
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja incluir as observações na impressão?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setImprimirDialogOpen(false)}>Cancelar</Button>
          <Button onClick={() => confirmarImpressao(false)} color="primary">
            Sem Observações
          </Button>
          <Button
            onClick={() => confirmarImpressao(true)}
            color="primary"
            variant="contained"
          >
            Com Observações
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ProcedimentosTratamento;
